module.exports = __webpack_public_path__ + "img/20230912-085057.30f5d71c.webp";